module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showUi) ? _c('div', {
    staticClass: "flex"
  }, [_c('section', {
    staticClass: "flex-content"
  }, [_c('header', {
    staticClass: "uc-header",
    style: ('background: #1296db url(' + _vm.bgImg + '); ')
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('div', {
    staticClass: "avatar-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.info.img
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "header-left-info",
    style: ({
      color: _vm.fontColor
    })
  }, [_c('div', [_vm._v(_vm._s(_vm.info.nick_name))]), _vm._v(" "), _c('div', [(_vm.info.is_agent) ? _c('span', [_vm._v(_vm._s(_vm.info.agent_level))]) : _c('span', [_vm._v(" " + _vm._s(_vm._f("level")(_vm.info.level)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_c('div', {
    staticClass: "level-box"
  }, [_vm._v("ID: " + _vm._s(_vm.info.id))])])]), _vm._v(" "), (false) ? _c('group', [_c('cell', [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('p', [_vm._v("每日签到")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.checkInformation.thisMonthCheckedTimes > 0),
      expression: "info.checkInformation.thisMonthCheckedTimes > 0"
    }],
    staticStyle: {
      "font-size": "80%",
      "opacity": "0.5",
      "margin-top": "2px"
    }
  }, [_vm._v("您本月已签到\n            " + _vm._s(_vm.info.checkInformation.thisMonthCheckedTimes) + " 天")])]), _vm._v(" "), (_vm.info.checkInformation.todayChecked === false) ? _c('x-button', {
    attrs: {
      "plain": "",
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.checkMe($event)
      }
    }
  }, [_vm._v("\n          点击签到\n        ")]) : _c('x-button', {
    attrs: {
      "mini": ""
    }
  }, [_vm._v("已签到")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('cell', [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("体验活动")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "80%",
      "opacity": "0.5",
      "margin-top": "2px"
    }
  }, [_vm._v("\n            新用户参与填表，赢取红包奖励\n          ")])]), _vm._v(" "), _c('x-button', {
    attrs: {
      "type": "warn",
      "mini": "",
      "link": "/newyearactivity"
    }
  }, [_vm._v("\n          立即参与\n        ")])], 1)], 1), _vm._v(" "), _c('card', {
    attrs: {
      "header": {
        title: '资金概况 - 点击查看详情'
      }
    }
  }, [_c('div', {
    staticClass: "card-demo-flex card-demo-content01",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "vux-1px-r",
    on: {
      "click": function($event) {
        _vm.jump('balance')
      }
    }
  }, [_c('span', [_vm._v("账户余额")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.info.balance) + "\n        ")]), _vm._v(" "), (!_vm.info.is_agent) ? _c('div', {
    staticClass: "vux-1px-r",
    on: {
      "click": function($event) {
        _vm.jump('order')
      }
    }
  }, [_c('span', [_vm._v("订单数")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.info.orderNumber) + " 单\n        ")]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "vux-1px-r",
    on: {
      "click": function($event) {
        _vm.jump('integral')
      }
    }
  }, [_c('span', [_vm._v("积分")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.info.integral) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "个人订单"
    }
  }, [_c('grid', [_c('grid-item', {
    attrs: {
      "label": "待付款",
      "link": "/uc/order/willPay"
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": require("../../assets/will-pay.png")
    },
    slot: "icon"
  })]), _vm._v(" "), _c('grid-item', {
    attrs: {
      "label": "已付款",
      "link": "/uc/order/paid"
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": require("../../assets/sent.png")
    },
    slot: "icon"
  })]), _vm._v(" "), _c('grid-item', {
    attrs: {
      "label": "更多",
      "link": "/uc/order/all"
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": require("../../assets/allorder.png")
    },
    slot: "icon"
  })])], 1)], 1), _vm._v(" "), (_vm.info.is_agent) ? _c('group', {
    attrs: {
      "title": "出货订单 - 60天内"
    }
  }, [_c('grid', [_c('grid-item', {
    attrs: {
      "label": "未发货",
      "link": "/uc/agentorder/new_order"
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": require("../../assets/will-send.png")
    },
    slot: "icon"
  })]), _vm._v(" "), _c('grid-item', {
    attrs: {
      "label": "已发货",
      "link": "/uc/agentorder/sent_order"
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": require("../../assets/sent.png")
    },
    slot: "icon"
  })]), _vm._v(" "), _c('grid-item', {
    attrs: {
      "label": "全部",
      "link": "/uc/agentorder/all"
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": require("../../assets/allorder.png")
    },
    slot: "icon"
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showSellerRequest) ? _c('group', {
    attrs: {
      "title": "经销商申请"
    }
  }, [_c('cell', {
    attrs: {
      "title": "经销商申请",
      "value": "经销商在线申请",
      "isLink": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$router.push('/uc/seller-request')
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.info.promiseBalanceList !== null) ? _c('group', {
    attrs: {
      "label-width": "8em",
      "title": "代理情况"
    }
  }, [_c('cell', {
    attrs: {
      "title": "代理/经销商区域",
      "value": _vm.info.agentArea
    }
  }), _vm._v(" "), _vm._l((_vm.info.promiseBalanceList), function(item) {
    return _c('cell', {
      key: item.name,
      attrs: {
        "title": item.name,
        "isLink": "",
        "align-items": "flex-start",
        "value": ("库存 " + (item.amount) + " " + (item.unit_text))
      },
      nativeOn: {
        "click": function($event) {
          _vm.$router.push('/uc/promisebalancelist/' + item.id)
        }
      }
    })
  }), _vm._v(" "), (_vm.show_recharge) ? _c('cell', {
    attrs: {
      "title": "充值库存",
      "value": "库存商品可随时提取",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.jump('seller_recharge')
      }
    }
  }, [_c('img', {
    staticClass: "icon-mr-10",
    attrs: {
      "slot": "icon",
      "src": require("../../assets/touzi.png"),
      "width": "20"
    },
    slot: "icon"
  })]) : _vm._e(), _vm._v(" "), (_vm.show_get_back) ? _c('cell', {
    attrs: {
      "title": "提取库存",
      "value": "提取商品库存",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.jump('get_stock')
      }
    }
  }, [_c('img', {
    staticClass: "icon-mr-10",
    attrs: {
      "slot": "icon",
      "src": require("../../assets/out.png"),
      "width": "20"
    },
    slot: "icon"
  })]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('group', {
    attrs: {
      "title": "通用信息"
    }
  }, [_c('cell', {
    attrs: {
      "title": "未生效奖励",
      "value": _vm.info.temp_balance
    }
  }, [_c('img', {
    staticClass: "icon-mr-10",
    attrs: {
      "slot": "icon",
      "src": require("../../assets/touzi.png"),
      "width": "20"
    },
    slot: "icon"
  })]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "我的下级",
      "link": '/uc/child/' + _vm.info.id,
      "is-link": ""
    }
  }, [_c('img', {
    staticClass: "icon-mr-10",
    attrs: {
      "slot": "icon",
      "src": require("../../assets/xiaji.png"),
      "width": "20"
    },
    slot: "icon"
  })]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "推广二维码",
      "value": "获取推广名片和推荐码",
      "link": "/uc/referIndex",
      "is-link": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('img', {
    staticClass: "icon-mr-10",
    attrs: {
      "src": require("../../assets/erweima.png"),
      "width": "20"
    }
  })])]), _vm._v(" "), (_vm.info.ref_uid !== 0) ? _c('cell', {
    attrs: {
      "title": "我的推荐人",
      "value": "查看直接推荐人",
      "link": '/uc/refer/' + _vm.info.ref_uid
    }
  }, [_c('img', {
    staticClass: "icon-mr-10",
    attrs: {
      "slot": "icon",
      "src": require("../../assets/ref.png"),
      "width": "20"
    },
    slot: "icon"
  })]) : _vm._e(), _vm._v(" "), (false) ? _c('cell', {
    attrs: {
      "title": "我要投资",
      "value": "成为代理",
      "link": "/uc/joinus/",
      "is-link": ""
    }
  }, [_c('img', {
    staticClass: "icon-mr-10",
    attrs: {
      "slot": "icon",
      "src": require("../../assets/touzi.png"),
      "width": "20"
    },
    slot: "icon"
  })]) : _vm._e(), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "提现管理",
      "value": "现金提现",
      "link": "/uc/withdraw",
      "is-link": ""
    }
  }, [_c('img', {
    staticClass: "icon-mr-10",
    attrs: {
      "slot": "icon",
      "src": require("../../assets/wd.png"),
      "width": "20"
    },
    slot: "icon"
  })]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "个人设置",
      "link": "/uc/setting",
      "is-link": ""
    }
  }, [_c('img', {
    staticClass: "icon-mr-10",
    attrs: {
      "slot": "icon",
      "src": require("../../assets/setting.png"),
      "width": "20"
    },
    slot: "icon"
  })]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "帮助中心",
      "link": "/news/cate/8",
      "is-link": ""
    }
  }, [_c('img', {
    staticClass: "icon-mr-10",
    attrs: {
      "slot": "icon",
      "src": require("../../assets/help.png"),
      "width": "20"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('group', {
    staticStyle: {
      "margin": "0 10px"
    }
  }, [_c('x-button', {
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.logout($event)
      }
    }
  }, [_vm._v("注销清理")])], 1), _vm._v(" "), _c('divider', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("天一互联 v" + _vm._s(_vm.version))])], 1), _vm._v(" "), _c('div', [_c('x-dialog', {
    staticClass: "dialog-demo",
    model: {
      value: (_vm.showQr),
      callback: function($$v) {
        _vm.showQr = $$v
      },
      expression: "showQr"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "red",
      "font-weight": "bold",
      "padding-top": "5px"
    }
  }, [_vm._v("分享此二维码 - 获取佣金")]), _vm._v(" "), _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": _vm.qrCode
    }
  })]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.showQr = false
      }
    }
  }, [_c('span', {
    staticClass: "vux-close"
  })])])], 1), _vm._v(" "), _c('foot-nav', {
    attrs: {
      "selectBar": "uc"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-455c58cc"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/Index.vue
// module id = 676
// module chunks = 0